<template>
  <Form
    :fields="fields"
    :showErrors="showErrors"
    :data="value"
    :serverErrors="serverErrors"
    :disabled="disabled"
    @input="data => $emit('input', data)"
    @valid="valid => $emit('valid', valid)"
  />
</template>

<script>
import _ from "lodash";
import Form from "@/components/Form.vue";

export default {
  name: "ContactInformation",

  components: { Form },

  props: ["value", "showErrors", "serverErrors", "disabled"],

  computed: {
    fields() {
      return [
        {
          id: "name",
          title: "Your Name",
          type: "text",
          required: true,
          rules: [["min", 2], "name"]
        },
        {
          id: "email",
          title: "Email Address",
          type: "text",
          required: true,
          rules: ["email"]
        },
        {
          id: "company_name",
          title: "Company Name",
          type: "text",
          required: true
        },
        {
          id: "customer_name",
          title: "Customer Name",
          type: "text",
          required: true
        }
      ];
    }
  }
};
</script>
